import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateDiscordIntegrationMutation = createMutationHook(
  MembershipsCreatorApiClient.createDiscordIntegration,
  {
    mutationKey: ['createDiscordIntegration'],
  },
)
